import React, { useState } from "react";

//components
import { Button } from 'react-bulma-components';
import { Thumbnail } from "shared/components/user";
import { ChevronDown, ChevronUp, Trash2 } from 'react-feather';

// utils
import { getUserInitials } from "shared/utils";

import styles from './Contacts.module.scss';

const ContactsTable = ({ data = false, onSelect, onRemove }) => {
    const [order, setOrder] = useState('asc');
    const [tableData, setTableData] = useState(data);

    const Arrow = () => {
        return order === 'asc'
            ? <ChevronDown size={20} strokeWidth={1.5} className={ styles.icon } title="Sort Asc"/>
            : <ChevronUp size={20} strokeWidth={1.5} className={ styles.icon } />;
    }

    const handleSort = (sortField) => {
        setOrder(order === 'asc' ? 'desc' : 'asc');

        const sorted = [...tableData].sort((a, b) =>
              a[sortField].toString().localeCompare(b[sortField].toString()) * (order === "asc" ? 1 : -1)
        );

        setTableData(sorted);
    }


    return (
        <table className="table is-hoverable is-fullwidth">
            <thead>
                <tr>
                    <td></td>
                    <td>
                        <div className={ styles.header } onClick={ () => handleSort('name') }>
                            <strong>Full name</strong>
                            <Arrow />
                        </div>
                    </td>
                    <td>
                        <div className={ styles.header }>
                            <strong>Email</strong>
                        </div>
                    </td>
                    <td>
                        <div className={ styles.header }>
                            <strong>Company</strong>
                        </div>
                    </td>
                    <td>
                        <div className={ styles.header }>
                            <strong>Owner</strong>
                        </div>
                    </td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                { tableData && tableData.map((contact, index) => {
                    // in case of no image
                    const initials = getUserInitials(contact.name, contact.surname);

                    return <tr key={ index }>
                        <td style={{paddingLeft: '5rem', verticalAlign: 'middle'}}>
                            <Thumbnail
                                initials={ initials }
                                image={ contact.image } />
                        </td>
                        <td
                            className="has-text-left"
                            style={{ verticalAlign: 'middle', cursor: 'pointer'}}
                            onClick={ ()=> onSelect(contact) }>
                            { contact.name } { contact.surname }
                        </td>
                        <td
                            className="has-text-left"
                            style={{ verticalAlign: 'middle', fontSize: '1.4rem'}}>
                            { contact.email }
                        </td>
                        <td
                            className="has-text-left"
                            style={{ verticalAlign: 'middle'}}>
                            { contact.company.name }
                        </td>
                        <td
                            className="has-text-left"
                            style={{ verticalAlign: 'middle'}}>
                            { contact.contact_owner.name }
                        </td>
                        <td className="has-text-right"
                            style={{paddingRight: '5rem', verticalAlign: 'middle'}}>
                            <Button
                                className={ styles.delete }
                                text
                                onClick={ ()=> onRemove(contact) } >
                                <Trash2 size={18} strokeWidth={1.5} />
                            </Button>
                        </td>
                    </tr>
                })}
            </tbody>
        </table>
    )
}


export default ContactsTable;
